import script from "./AlertInfoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertInfoCard.vue?vue&type=script&setup=true&lang=js"

import "./AlertInfoCard.vue?vue&type=style&index=0&id=500ec958&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-500ec958"]])

export default __exports__
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCardSection,QList,QItem,QItemSection,QAvatar,QItemLabel,QInnerLoading});
